import $ from 'jquery';

import Common from './base/common';
import Layout from './base/layout';
import calendySetup from './base/calendySetup';
import './base/footer';

$(() => {
	const layout = new Layout();
    layout.init();

  const common = new Common();
  common.init();

  calendySetup();
});
